<div class="mt-2">
  <mat-accordion id="ruleDetails">
    <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
      <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
      <mat-expansion-panel-header class="ia-mat-panel">
        <mat-panel-title>
          <span class="text-header inc-f"> RULE DETAILS </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div id="ruleDetails">
        <div class="row ml-2 mt-4">
          <div class="col-lg-2">
            <label class="control-label fw">Change ID</label>
            <div class="pt-1 d-flex flex-wrap gap-1" *ngIf="selftassessmentSummary.rulebookRuleID">
              <!-- <p class="mb-0" *ngFor="let rId of selftassessmentSummary.rulebookRuleID.split('|')"><a (click)="openView(rId,2)" target="_blank">{{rId}}</a></p> -->
              <a class="mb-0 redirect_tag" *ngFor="let rId of selftassessmentSummary.rulebookRuleID.split('|')"
                (click)="openView(rId, 2)" target="_blank">{{ rId }}</a>
            </div>
          </div>
          <div class="col-md-8 col-lg-8">
            <div class="form-group">
              <div class="left inline label-heading control-label mb-1 fw">Part</div>
              <div class="input-group self_part pt-1">
                <p class="mb-0" *ngFor="let rPart of selftassessmentSummary.part.split(',')">{{rPart}}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-2">
            <label class="control-label fw">Regulator</label>
            <div class="pt-1" *ngIf="selftassessmentSummary.regulator">
              <p class="mb-0" *ngFor="let item of selftassessmentSummary.regulator.split('|')">{{item}}</p>
            </div>
          </div>
        </div>
        <div class="row ml-2 mt-3">
          <div class="col-lg-3">
            <label class="control-label fw">Date</label>
            <div class="pt-2 control-label">{{selftassessmentSummary.effectiveDate}}</div>
          </div>
          <div class="col-lg-3">
            <label class="control-label fw">Rulebook</label>
            <div class="pt-2" *ngIf="selftassessmentSummary.ruleBook">
              <p class="mb-0" *ngFor="let item of selftassessmentSummary.ruleBook.split('|')">{{item}}</p>
            </div>
          </div>
          <div class="col-lg-3">
            <label class="control-label fw">Rule ID</label>
            <div class="pt-2" *ngIf="selftassessmentSummary.ruleID">
              <p class="mb-0" *ngFor="let item of selftassessmentSummary.ruleID.split('|')">{{item}}</p>
            </div>
          </div>
          <!-- <div class="col-lg-3">
              <label class="control-label fw">Division</label>
              <div class="pt-2 control-label">{{selftassessmentSummary.jurisdiction}}</div>
            </div> -->
            <div class="col-lg-3"
              *ngIf="selfassessmentSummaryFromParent.isRecordTime">
              <label class="control-label fw">Time Spent </label>
              <div class="control-label">{{selfassessmentSummaryFromParent.timeSpent | minToHour}}</div>
            </div>
        </div>
        <div class="row ml-2 mt-4">
          <div class="col-lg-10 fw">
            <label class="control-label fw">Description</label>
            <div class="edit_status_changeViewer_group">
              <div *ngFor="let item of selftassessmentSummary.regulatoryRuleFullRequirement.split('|')">
                <div *ngIf="item | hasHtmlTags; else noHtmlTags" [innerHTML]="item"></div>
                <ng-template #noHtmlTags>
                  <mat-form-field class="disableText w-100">
                    <textarea matInput cdkTextareaAutosize disabled class="text-area-css textarea_input">{{item}}</textarea>
                  </mat-form-field>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="col-lg-2" *ngIf="selftassessmentSummary.hyperlink">
            <a href="{{selftassessmentSummary.hyperlink}}" target="_blank">
              <i class="fa fa-globe"></i>
              <span class="text-primary cursor-pointer">
                Source Link</span>
            </a>
          </div>
          <div class="col-lg-2" *ngIf="!selftassessmentSummary.hyperlink">
            <i class="fa fa-globe"></i><span> Source Link</span>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
